import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { format } from 'react-phone-input-auto-format';
import PropTypes from 'prop-types';
import { Chat } from '@one-thd/sui-icons';
import { clickEvents } from '../../../../utils/analytics';
import { markCandidateAsPhoned, getCustomerEligibility } from '../../../../api/SlmService';
import './ContactButtons.scss';

const TextMeButton = ({ phoneNumber, candidateId, textOptIn }) => {

  if (!textOptIn) {
    return null;
  }

  const markAsViewed = () => {
    markCandidateAsPhoned(candidateId).catch((error) => {
      console.error('Error marking candidate as contacted', error);
    });
  };

  const handleClick = async () => {
    try {
      const response = await getCustomerEligibility();
      let localCustomer = response?.data?.cicCustomer || {};

      const smsBody = `Hello, this is ${localCustomer?.user?.firstName} with ${localCustomer?.businessName}. I found your information on The Home Depot Path to Pro Network and wanted to reach out about a potential job opportunity. Would you be open to discussing this via text?
      Msg & data rates may apply. Reply STOP to end messages from ${localCustomer?.businessName}. For HELP, email Path_to_Pro@homedepot.com`;

      const smsHref = `sms:${phoneNumber}?body=${encodeURIComponent(smsBody)}`;
      clickEvents.candidatePageInteraction('contact', 'text', candidateId);
      markAsViewed();
      window.location.href = smsHref;
    } catch (error) {
      console.error('Failed to fetch customer eligibility', error);

    }
  };

  if (!phoneNumber) {
    return (
      <div className="contact-button">
        <Button disabled>
          <span className="contact-button__icon">
            <Chat size="small" />
          </span>
          <span className="contact-button__label">
            Text
          </span>
        </Button>
      </div>
    );
  }

  return (
    <div className="contact-button">
      <Tooltip
        channel="desktop"
        closeButton
        content={(
          <div className="contact-button__tooltip" data-testid="text-me-btn-tooltip">
            {format(phoneNumber || '')}
          </div>
        )}
        showClose={false}
      >
        <div
          onClick={handleClick}
          className="contact-button__btn primary"
        >
          <span className="contact-button__icon">
            <Chat style={{ fontSize: '32px' }} />
          </span>
          <span className="contact-button__label">
            Text
          </span>
        </div>
      </Tooltip>
    </div>
  );
};

TextMeButton.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  candidateId: PropTypes.number.isRequired,
  textOptIn: PropTypes.bool.isRequired
};

export default TextMeButton;
